"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocallyFilteringList = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var FilteringList_1 = require("./FilteringList");
var ListItemUtils_1 = require("./ListItemUtils");
/** `FilteringList` with default filtering behavior. */
var LocallyFilteringList = /** @class */ (function (_super) {
    tslib_1.__extends(LocallyFilteringList, _super);
    function LocallyFilteringList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listRef = React.createRef();
        _this.state = LocallyFilteringList.defaultStateFor(_this.props);
        _this.handleFilterChange = function (value) {
            var filteredItems = ListItemUtils_1.standardItemFilter(_this.props.items, value, _this.props.itemFilterFn);
            if (filteredItems.length === 0) {
                filteredItems.push({ value: FilteringList_1.FilteringListMessages.noMatches(), disabled: true });
            }
            _this.setState({
                searchText: value,
                filteredItems: filteredItems,
            });
        };
        return _this;
    }
    LocallyFilteringList.defaultStateFor = function (props) {
        return {
            filteredItems: props.items,
            searchText: '',
        };
    };
    LocallyFilteringList.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.items !== this.props.items || prevProps.itemFilterFn !== this.props.itemFilterFn) {
            this.handleFilterChange(this.state.searchText);
        }
    };
    /** Gets the index into `props.items` of the pseudo-focused listbox option. */
    LocallyFilteringList.prototype.getActiveItemIndex = function () {
        var _a, _b;
        return (_b = (_a = this.listRef.current) === null || _a === void 0 ? void 0 : _a.getActiveItemIndex()) !== null && _b !== void 0 ? _b : -1;
    };
    LocallyFilteringList.prototype.render = function () {
        var _a = this.props, items = _a.items, itemFilterFn = _a.itemFilterFn, listProps = tslib_1.__rest(_a, ["items", "itemFilterFn"]);
        return (React.createElement(FilteringList_1.FilteringList, tslib_1.__assign({}, listProps, { items: this.state.filteredItems, onFilterChange: this.handleFilterChange, ref: this.listRef, searchText: this.state.searchText })));
    };
    return LocallyFilteringList;
}(React.PureComponent));
exports.LocallyFilteringList = LocallyFilteringList;
//# sourceMappingURL=LocallyFilteringList.js.map